module.exports = __webpack_public_path__ + "img/choujiang_bg_1@3x.48f6554a.png";